import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import QRCode from "qrcode";
import Storage from "@aws-amplify/storage";

const LOGO_SCALE_SIZE = 0.2;

const QRElement = ({ url, displayLogoInQRCode = false, logoKey }) => {
  const generateQR = useCallback(async () => {
    const canvas = document.getElementById("canvas");

    if (!displayLogoInQRCode) {
      const img = document.getElementById("logo-in-qr");
      if (img) canvas.removeChild(img);
    }

    if (displayLogoInQRCode && logoKey) {
      const logoUrl = await Storage.get(logoKey);

      // Adding a logo at center
      const context = canvas.getContext("2d");
      const image = new Image();
      image.crossOrigin = "Anonymous";
      image.src = logoUrl;
      image.alt = "logo-in-qr";
      image.id = "logo-in-qr";
      image.hidden = true;
      // For unit testing purpose
      canvas.appendChild(image);

      image.onload = () => {
        const dwidth = canvas.width * LOGO_SCALE_SIZE;
        const dheight = (image.height / image.width) * dwidth;
        const dx = (canvas.width - dwidth) / 2;
        const dy = (canvas.width - dheight) / 2;
        context.drawImage(image, dx, dy, dwidth, dheight);
      };
    }
    QRCode.toCanvas(canvas, url, (error) => {
      if (error) console.error(error);
      //console.log('success!')
    });
  }, [url, displayLogoInQRCode, logoKey]);

  useEffect(() => {
    generateQR();
  }, [generateQR]);

  return <canvas id="canvas" />;
};

QRElement.propTypes = {
  url: PropTypes.string.isRequired,
  displayLogoInQRCode: PropTypes.bool,
  logoKey: PropTypes.string,
};

export default QRElement;
